const trains = {
  train: "기차", // translated 
  trains: "기차", // translated 
  fairConditions: "공정한 조건", // translated 
  to: "에게", // translated 
  earlier: "더 일찍", // translated 
  later: "나중에", // translated 
  adults: "성인", // translated 
  child: "어린이", // translated 
  senior: "상위", // translated 
  seniors: "어른", // translated 
  price: "가격", // translated 
  for: "~을 위한", // translated 
  total: "총", // translated 
  selected: "선택된", // translated 
  prebook: "사전 예약", // translated 
  book: "책", // translated 
  payment: "지불", // translated 
  return: "반품", // translated 
  passengers: "승객들", // translated 
  delivery: "배달", // translated 
  summary: "요약", // translated 
  checkout: "점검", // translated 
  trainToastCorrectFillForm: "모든 항목을 정확하게 입력해 주십시오.", // translated 
  fareConditions: "운임 조건", // translated 
  travelInfo: "여행 정보", // translated 
  remarks: "고객 의견", // translated 
  noServices: "서비스 없음", // translated 
  timesAndSeats: "시간 및 좌석", // translated 
  mobileTicket: "모바일 티켓", // translated 
  stationTicket: "역에서 수령하세요", // translated 
  homeTicket: "집에서 인쇄하세요", // translated 
  countryCode: "국가 코드", // translated 
  chooseTicket: "티켓 배송 방법을 선택하세요", // translated 
  ticketError: "모든 목적지행 티켓을 선택해 주세요.", // translated 
  ticketDelivery: "티켓 수령 방법을 선택해 주세요.", // translated 
  passengerDetails: "승객 정보", // translated 
  waitWhileProcessingPayment:
    "결제 처리가 진행되는 동안 잠시 기다려 주십시오. 페이지를 새로고침하거나 닫지 마십시오.", // translated 
  reductionCardId: "할인 카드 ID", // translated 
  countryOfResidence: "거주 국가", // translated 
  countryOfBirth: "출생 국가", // translated 
  documentCountry: "문서 국가", // translated 
  documentNumber: "문서 번호", // translated 
  expirationDate: "만료일", // translated 
  documentType: "문서 유형", // translated 
  travelerDocumentInfo: "여행자 서류 정보", // translated 
  youth: "청년", // translated 
  youths: "청소년", // translated 
  departTimeEarlyFirst: "출발 시간 (가장 빠른 시간부터)", // translated 
};


export default trains;
